// Opening the Channels screen from Console.
//
// Channels is its own app (WP-CH-16), a peer of Designer and Explorer, so it is
// reached the same way they are: a service URL held in sysconfig, opened in a
// named window so a second click focuses the tab that is already open instead of
// making another one.
//
// Local Console may fall back to the standalone development server. Production
// is deliberately fail-closed: it only enables the control after sysconfig has
// an explicit `services.channels` address.

import { getServiceUrl } from '../sysconfig';

const WINDOW_NAME = 'CloudSamChannels';
const LOCAL_DEV_URL = 'http://localhost:3004';

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

export function resolveChannelsBase(serviceUrl, hostname) {
    const configured = String(serviceUrl || '').trim();
    if (configured) return configured.replace(/\/+$/, '');
    if (LOCAL_HOSTS.has(hostname || '')) return LOCAL_DEV_URL;
    throw new Error('The Channels screen has no address in sysconfig, so it cannot be opened.');
}

/**
 * The base address of the Channels app.
 * @returns {Promise<string>} the URL, with no trailing slash
 * @throws when no address is configured and Console is not running locally
 */
export async function getChannelsBase() {
    let serviceUrl = '';
    try {
        serviceUrl = (await getServiceUrl('channels')) || '';
    } catch (err) {
        serviceUrl = '';
    }
    const hostname = (typeof window !== 'undefined' && window.location && window.location.hostname) || '';
    return resolveChannelsBase(serviceUrl, hostname);
}

/** Open Channels on its own opening view. */
export async function openChannels() {
    const base = await getChannelsBase();
    window.open(`${base}/?view=channels`, WINDOW_NAME);
}
